import "./PageNotFound.css";

function PageNotFound() {
  return (
    <div className="page-not-found">
      <h2>Page Not Found - 404</h2>
      <ul>
        {/* <li>Back</li> */}
      </ul>
    </div>
  );
}

export default PageNotFound;
